import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

function makeCompoundName(annotation: any, shape: any) {
  return `${annotation.name} ${shape.name}`;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_314: DocMigration = {
  maxSchemaVersion: "0.0.314",
  description: "Flatten annotation linework shapes",
  apply(json: any) {
    for (const annotationId in json.annotation) {
      const annotation = json.annotation[annotationId];

      if (annotation.type !== "LINEWORK") {
        continue;
      }

      // copy shapes and delete early to avoid adding them to new annotations
      const shapesCopy = { ...annotation.shapes };
      delete json.annotation[annotationId].shapes;

      const existingGroupId = json.entityGroups[`annotation.${annotationId}`];

      let i = 0;
      const shapesCount = Object.keys(shapesCopy).length;

      // if there are multiple shapes and the original annotation is not already in a group, create a group to contain them
      let newGroupId: string | undefined;
      if (shapesCount > 1 && !existingGroupId) {
        newGroupId = uid();
        json.groups[newGroupId] = {
          id: newGroupId,
          sortIndex: annotation.sortIndex,
          name: annotation.name,
          entityType: "GROUP",
        };
      }

      for (const shapeId in shapesCopy) {
        const shape = shapesCopy[shapeId] as { name: string };
        if (i === 0) {
          if (newGroupId) {
            json.entityGroups[`annotation.${annotationId}`] = newGroupId;
            // move a condition to the group
            json.groups[newGroupId].disabled = annotation.disabled;
            delete annotation.disabled;
          }

          // spread the shape into the existing annotation
          json.annotation[annotationId] = {
            ...annotation,
            ...shape,
            name: makeCompoundName(annotation, shape),
          };
        } else {
          // create a new annotation
          const newAnnotationId = uid();
          json.annotation[newAnnotationId] = {
            ...annotation,
            ...shape,
            id: newAnnotationId,
            name: makeCompoundName(annotation, shape),
          };
          if (existingGroupId) {
            json.entityGroups[`annotation.${newAnnotationId}`] = existingGroupId;
          } else if (newGroupId) {
            json.entityGroups[`annotation.${newAnnotationId}`] = newGroupId;
          }
        }
        i++;
      }
    }

    for (const settingsId in json.settings) {
      const settings = json.settings[settingsId];
      if (settings.type !== "ANNOTATION_CATALOG_SETTINGS") {
        continue;
      }

      for (const annotationTemplateId in settings.annotationTemplates) {
        const annotationTemplate = settings.annotationTemplates[annotationTemplateId];

        for (const componentId in annotationTemplate.components) {
          const component = annotationTemplate.components[componentId];
          if (component.type !== "LINEWORK") {
            continue;
          }

          // copy shapes and delete early to avoid adding them to new annotations
          const shapesCopy = { ...component.shapes };
          delete component.shapes;

          let i = 0;

          for (const shapeId in shapesCopy) {
            const shape = shapesCopy[shapeId] as {};
            if (i === 0) {
              // spread the shape into the existing component
              json.settings[settingsId].annotationTemplates[annotationTemplateId].components[componentId] = {
                ...component,
                ...shape,
                name: makeCompoundName(component, shape),
              };
            } else {
              // create a new component
              const newComponentId = uid();
              const newComponent = {
                ...component,
                ...shape,
                name: makeCompoundName(component, shape),
              };

              const newHandle = { ...component.handle };
              newHandle.componentId = newComponentId;
              newComponent.handle = newHandle;

              json.settings[settingsId].annotationTemplates[annotationTemplateId].components[newComponentId] =
                newComponent;
            }
            i++;
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_314;
